<template>
	<modal name="language-settings" :width="300" :height="150">
		<div id="language-settings-modal">
			<h1>Language / Jazyk</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('language-settings')" />
			<SwitchLanguage />
		</div>
	</modal>
</template>

<script>
	import IconTimes from "@/components/icons/IconTimes";
	import SwitchLanguage from "../language/SwitchLanguage";

	export default {
		components: {
			SwitchLanguage,
			IconTimes
		}
	}
</script>

<style lang="scss" scoped>
	#language-settings-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}
	}
</style>
